export const MODAL_SERVICE = 'MODAL_SERVICE';
export const TOASTER_SERVICE = 'TOASTER_SERVICE';
